module.exports = __webpack_public_path__ + "static/media/google-icon.c2826e29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sso/google-icon.png
// module id = 1802
// module chunks = 0